export const LOADING_ACTIONS = {
  DELETE: "deleteWarehouse",
};
